import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const MeliAccess = lazy(() => import('../MeliAccess'));

const MeliAccessRoutes: RouteObject[] = [
  {
    path: 'meli-access',
    element: <MeliAccess />,
  },
];

export default MeliAccessRoutes;
